import React, { useContext } from 'react';
import DocumentUploadContext from '../../context/DocumentUpload/documentUploadContext';
import SchedulerMain from '../../pages/SchedulerMain';
import Upload from '../../pages/Upload';
import SelectSchedule from '../../pages/SelectSchedule';
import Acknowledgement from '../../pages/Acknowledgement';
import NoticePage from '../../pages/NoticePage';
import SelectScheduleSummary from '../../pages/SelectScheduleSummary';
import SchedulerAcknowledgement from '../../pages/SchedulerAcknowledgement';
const SchedulerForm = () => {
  const documentUploadContext = useContext(DocumentUploadContext);
  const currentURL = window.location.href;
  switch (documentUploadContext.step) {
    case 0:
      return <SchedulerMain />;
    case 1:
      return currentURL.includes("Scheduler") ? <SelectSchedule /> : <Upload /> ;
    case 2:
      return <Acknowledgement />;
    case 3:
      return <NoticePage />;
    case 4:
      return <SelectScheduleSummary />;
    case 5:
      return <SchedulerAcknowledgement />;
    default:
      return <h1>{''}</h1>;
  }
};
export default SchedulerForm;
